import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'
import { getUserSessionState } from '../../../selectors/user'

import {
    fetchAccountList,
    generateStatement,
    generateborderaux,
    remove_entry,
    mark_as_paid,
} from '../../../actions'

import Accounts from '../../../components/pages/Accounts/Accounts'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        userSession: getUserSessionState(state),
        accounts: state.accounts,
    }
}

export default connect(mapStateToProps, {
    fetchAccountList,
    generateStatement,
    generateborderaux,
    remove_entry,
    mark_as_paid,
})(Accounts)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Accounts/Accounts.tsx